import {
  Box,
  Icon,
  IconName,
  Inline,
  Text,
  useForegroundVariantColor,
  useTheme
} from "@seneca/senekit";

export const SIDEBAR_MENU_ITEM_HEIGHT = 56;

type Props = {
  label: string;
  iconName: IconName;
  active: boolean;
  onClick: () => void;
  tag?: JSX.Element;
};

export default function SidebarMenuItem({
  label,
  iconName,
  active,
  onClick,
  tag
}: Props) {
  const theme = useTheme();
  const foregroundVariantColor = useForegroundVariantColor("1");

  return (
    <Box
      component="button"
      onClick={onClick}
      width="100%"
      border="0"
      padding="none"
      background="transparent"
      cursor="pointer"
    >
      <Box
        display="flex"
        height={`${SIDEBAR_MENU_ITEM_HEIGHT}px`}
        paddingX="12"
        borderRadius="medium"
        backgroundColor={
          active ? theme["primary-low-surface"] : theme.foreground
        }
        hoverStyles={{
          backgroundColor: active
            ? theme["primary-medium-surface"]
            : foregroundVariantColor
        }}
      >
        <Inline space="large" alignItems="center">
          <Icon
            iconName={iconName}
            tone={active ? "primary" : "neutral"}
            accessibilityLabel={null}
          />
          <Text
            tone={active ? "primary" : "neutral"}
            weight={active ? "bold" : "normal"}
          >
            {label}
          </Text>
          {tag}
        </Inline>
      </Box>
    </Box>
  );
}
